import React, { useEffect, useState } from "react";
import {
  Box,
  Link,
  Button,
  IconButton,
  Modal,
  Tooltip,
  InputLabel,
  CircularProgress,
  Typography,
  Card,
  Grid,
  CardContent,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Alert,
  AlertTitle,
  Autocomplete,
  Backdrop,
} from "@mui/material";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import { Theme, useTheme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import { checkForRole } from "../../utils/GetAuth";
import { useLocalStorage } from "../../utils/LocalStorageHook";
import {
  getPriceChangePriceGroups,
  downloadPriceGroupCSV,
  uploadPriceGroupCSV,
  savePriceGroup,
  deletePriceGroup,
} from "../../utils/RemotePriceManagement";
import _, { forEach, set } from "lodash";
import { determineConfigLong, displayConfig } from "../../utils/GetContext";
import TableAbstraction from "../../componentUtils/TableAbstraction";
import LockIcon from "@mui/icons-material/Lock";
import AddIcon from "@mui/icons-material/Add";
import UndoIcon from "@mui/icons-material/Undo";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import Clear from "@mui/icons-material/Clear";
import GetApp from "@mui/icons-material/GetApp";
import Attachment from "@mui/icons-material/Attachment";
import Publish from "@mui/icons-material/Publish";

import RocketIcon from "@mui/icons-material/RocketLaunch";
import HdrAutoOutlinedIcon from "@mui/icons-material/HdrAutoOutlined";
import PersonPinCircleOutlinedIcon from "@mui/icons-material/PersonPinCircleOutlined";

function getModalStyle() {
  const top = 45;
  const left = 45;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
    width: `70%`,
  };
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    root: {},
    divWidth: {
      width: "100%",
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    modalGrid: {
      marginTop: theme.spacing(2),
    },
    modalTitle: {
      color: theme.palette.primary.main,
    },
    modalCard: {},
    modalText: {},
    modalInput: {
      width: "350px",
    },
    paper: {
      position: "absolute",
      backgroundColor: theme.palette.background.paper,
      border: `1px solid`,
      borderColor: theme.palette.border.main,
      boxShadow: theme.shadows[4],
      padding: theme.spacing(2, 2, 2),
    },
    paragraph: {
      padding: theme.spacing(1),
    },
    paragraphAct: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    paragraphButton: {
      marginLeft: theme.spacing(2),
      minWidth: 160,
    },
    card: {},
  })
);

interface alertFields {
  alertTitle: any;
  alertMessage: any;
  alertProceedButton: any;
  alertDenyButton: any;
  alertDisable: boolean;
  isAlertOpen: boolean;
}

const steps = ["Create Price Group"];

export default function PriceChangePriceGroups() {
  const classes = useStyles();
  const [priceGroupData, setPriceGroupData] = useState<any[]>([]);
  const [groupedPriceGroupData, setGroupedPriceGroupData] = useState<any[]>([]);
  const [combinedGroupMatrialList, setCombinedGroupMatrialList] = useState<any[]>([]);
  const [codes, setCodes] = React.useState<any>();
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "");
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [clientId] = useLocalStorage("SETTINGS.clientId", "100");
  const enabled = checkForRole(clientId, salesOrg, "vp_admin");
  const [muiTable, setMuiTable] = React.useState<any>({ rpp: 25 });
  const [confirmDelete, setConfirmDelete] = React.useState<boolean>(false);

  const [editedRowParamName, setEditedRowParamName] = React.useState<string>("");
  const [fileName, setfileName] = React.useState<string>();
  const [selectedFile, setSelectedFile] = React.useState<File>();
  const [rowMaterial, setRowMaterial] = useState<any>({
    searchMaterial: null,
  });
  const [modifyTableData, setModifyTableData] = useState<any>([]);
  const [openMaterialDetailsPopup, setOpenMaterialDetailsPopup] = React.useState(false);
  const [materialDetailsPopupData, setMaterialDetailsPopupData] = useState<any[]>([]);
  const [bulkSummary, setBulkSummary] = React.useState<{ valid: number; invalid: number }>();
  const [bulkADD, setBulkADD] =
    React.useState<
      { salesOffice: string; customerNum: string; noteType: string; validUntilDt: string; text: string }[]
    >();
  const [bulkKeyId, setBulkKeyId] = React.useState<string>();
  const [bulkMessage, setBulkMessage] = React.useState<string>();
  const [bulkErrorBody, setBulkErrorBody] = React.useState<any>();
  const [backdropLoader, setBackdropLoader] = React.useState<boolean>(false);
  const [customGroupName, setCustomGroupName] = React.useState<string>("");
  const [disabledSaveButton, setDisabledSaveButton] = React.useState<boolean>(false);
  const [recoredToBeDeleted, setRecoredToBeDeleted] = React.useState<any>();
  const [dynamicColsForMatDetls, setDynamicColsForMatDetls] = React.useState<any>();

  const [commonAlert, setCommonAlert] = useState<alertFields>({
    alertTitle: "",
    alertMessage: "",
    alertProceedButton: false,
    alertDenyButton: false,
    alertDisable: false,
    isAlertOpen: false,
  });

  const [modalStyle] = React.useState(getModalStyle);
  const [comingSoonPopup, setComingSoonPopup] = React.useState<boolean>(false);
  const [isEditOperation, setIsEditOperation] = React.useState<boolean>(false);
  const [activeStep, setActiveStep] = React.useState(0);
  const [isLandingPage, setIsLandingPage] = React.useState<boolean>(true);

  const CUSTOM_GROUP_TYPE = "CUSTOM";
  const RESERVED_GROUP_TYPE = "RESERVED";

  //function to group the data by groupname
  const groupByGroupName = (data: any) => {
    const output = Object.values(
      data.reduce((groups: any, item: any) => {
        const key = item.groupname;

        if (!groups[key]) {
          groups[key] = {
            groupname: item.groupname.trim(),
            groupcode: item.groupcode.trim(),
            group_type: item.is_auto ? RESERVED_GROUP_TYPE : CUSTOM_GROUP_TYPE,
            pack_size: item.pack_size,
            pack_type: item.pack_type,
            beverage_cat: item.beverage_cat,
            brand: item.brand,
            materialCount: 0,
            valid: "Yes",
            is_mat: false,
            is_auto: item.is_auto,
          };
        }

        groups[key].materialCount++;

        return groups;
      }, {})
    );

    return output;
  };

  useEffect(() => {
    if (customGroupName != "" && modifyTableData.length) {
      setDisabledSaveButton(false);
    } else {
      setDisabledSaveButton(true);
    }
  }, [customGroupName, modifyTableData]);

  useEffect(() => {
    if (doneLoading) return;
    //Implement API calling to get list of price change request
    getPriceChangePriceGroups(salesOrg)
      .then((responsePriceGroup) => {
        if (responsePriceGroup && responsePriceGroup.length) {
          setDoneLoading(true);
          setPriceGroupData(_.cloneDeep(responsePriceGroup));
          let groupedPriceGroupObj = groupByGroupName(responsePriceGroup);
          setGroupedPriceGroupData(groupedPriceGroupObj);

          const uniqueMaterialList: any = [...new Set(responsePriceGroup.filter((ele: any) => ele?.is_mat))];
          const formattedMaterialList: any = uniqueMaterialList.map((ele: any) => {
            ele.groupname = `${parseInt(ele?.material_num, 10)}-${ele?.description}`;
            ele.is_mat = true;
            ele.is_auto = false;
            ele.valid = "Yes";
            delete ele?.groupcode;
            return ele;
          });

          //
          groupedPriceGroupObj = groupedPriceGroupObj.filter((ele: any) => ele?.is_auto == 1);
          setCombinedGroupMatrialList([...groupedPriceGroupObj, ...formattedMaterialList]);
        }
        setIsLandingPage(true);
      })
      .catch(() => setDoneLoading(true));
  }, [doneLoading, groupedPriceGroupData, salesOrg]);

  const handleDelete = () => {
    setBackdropLoader(true);
    deletePriceGroup(salesOrg, recoredToBeDeleted)
      .then((response: any) => {
        if (response && response?.data?.result) {
          setTimeout(() => {
            setDoneLoading(false);
            setBackdropLoader(false);
            //handleModalClose();
          }, 1000);
        }
      })
      .catch((error: any) => {
        handleModalClose();
      });
  };

  const handleEdit = (tableRow: any) => {
    //

    const clonedPriceGroupData: any = _.cloneDeep(priceGroupData);
    const itemsByGroupName: any = clonedPriceGroupData.filter((ele: any) => ele?.groupname == tableRow?.groupname);
    const itemsByGroupCodeAndMaterialNum: any = itemsByGroupName.map((ele: any) => {
      let itemFound: any = undefined;
      if (ele?.is_mat) {
        itemFound = clonedPriceGroupData.find((item: any) => item?.material_num == ele?.group_item);
        ele.groupname = `${parseInt(itemFound?.material_num, 10)}-${itemFound?.description}`;
      } else {
        itemFound = clonedPriceGroupData.find((item: any) => item?.groupcode == ele?.group_item);
        ele.groupname = itemFound?.groupname;
        delete ele.material_num;
      }
      ele.valid = "Yes";
      return ele;
    });

    if (itemsByGroupCodeAndMaterialNum && itemsByGroupCodeAndMaterialNum.length) {
      const uniqueItems = Array.from(
        new Map(itemsByGroupCodeAndMaterialNum.map((item: any) => [item.groupname, item])).values()
      );
      setCustomGroupName(tableRow?.groupname);
      setModifyTableData(uniqueItems);
    }

    setIsLandingPage(false);
    setActiveStep(0);
  };

  const handleModalClose = () => {
    setBackdropLoader(false);
    setRowMaterial({});
    setModifyTableData([]);
    setIsEditOperation(false);
    setOpenMaterialDetailsPopup(false);
    setCustomGroupName("");
    setModifyTableData([]);
  };

  const handleModalSave = () => {
    setBackdropLoader(true);
    const priceGroupToBeSaved: any = {
      customGroupName: customGroupName,
      priceGroupObject: modifyTableData,
      operationType: isEditOperation ? "edit" : "save",
    };
    //
    savePriceGroup(salesOrg, priceGroupToBeSaved)
      .then((response: any) => {
        if (response && response?.status > 200) {
          const alert = {
            alertTitle: "Price Group Alert",
            alertMessage: response?.data?.message,
            isAlertOpen: true,
            alertProceedButton: false,
            alertDenyButton: false,
            alertDisable: false,
          };

          setCommonAlert(alert);
          handleModalClose();
          return;
        }
        //
        if (response && response?.data?.result) {
          setTimeout(() => {
            handleModalClose();
            setDoneLoading(false);
          }, 1000);
        }
      })
      .catch((error: any) => {
        handleModalClose();
      });
  };

  const handleAddTableData = () => {
    //handling duplicate group
    const duplicateItem: any = modifyTableData.find(
      (ele: any) => ele?.groupname == rowMaterial.searchMaterial?.groupname
    );
    if (duplicateItem) {
      const alert = {
        alertTitle: "Price Group Alert",
        alertMessage: `Not Allowed! You are trying to add duplicate ${
          duplicateItem?.is_mat ? "Material" : "Price Group"
        }: ${duplicateItem?.groupname}.`,
        isAlertOpen: true,
        alertProceedButton: false,
        alertDenyButton: false,
        alertDisable: false,
      };

      setCommonAlert(alert);
      return;
    }
    const newItemAdded: any = rowMaterial.searchMaterial;
    if (isEditOperation) {
      newItemAdded.group_item = newItemAdded.groupcode;
      newItemAdded.groupcode = "";
    }
    const updatedData: any = [...modifyTableData, newItemAdded];
    setModifyTableData(updatedData);
  };

  const handleTableDataDelete = (tableRow: any) => {
    let updatedData: any = modifyTableData.filter((ele: any) => ele.groupname.trim() != tableRow.groupname.trim());
    setModifyTableData(updatedData);
  };

  const dynamicallyChooseColsForMatDetls: any = (params: any) => {
    //
    let columns: any = [
      {
        label: "Material Number",
        name: "material_num",
        options: {
          filter: true,
        },
        valueGetter: (props: any) => {
          return props?.row.material_num.replace(/^0+/, "");
        },
      },
      {
        label: "Description",
        name: "description",
        options: {
          filter: true,
        },
      },
      {
        label: "Group Name",
        name: "groupname",
        valueGetter: (item: any) => {
          if (item?.row?.is_mat) {
            return `-`;
          } else {
            const itemFound: any = priceGroupData.find((ele: any) => ele?.groupcode == item?.row?.group_item);
            return itemFound.groupname;
          }
          //return item?.row?.is_auto ? item?.row?.pack_size : "-";
          return "--";
        },
        options: {
          filter: true,
        },
      },
      {
        label: "Pack Size",
        name: "pack_size",
      },
      {
        label: "Pack Type",
        name: "pack_type",
      },
      {
        label: "Beverage Category",
        name: "beverage_cat",
      },
      {
        label: "Brand",
        name: "brand",
      },
    ];
    if (params?.row?.is_auto) {
      columns = columns.filter((ele: any) => ele.name != "groupname");
    }

    return columns;
  };

  return (
    <>
      <div className={classes.root}>
        {isLandingPage ? (
          <div className={classes.root}>
            {doneLoading && enabled ? (
              <TableAbstraction
                settingsKey="ADM_OPT"
                options={{
                  draggableColumns: {
                    enabled: true,
                  },
                  rowsPerPageOptions: [25, 50, 100],
                  serverSide: false,
                  selectableRows: "none",
                  rowsPerPage: muiTable.rpp,
                  onChangeRowsPerPage: (numberOfRows) => {
                    muiTable.rpp = numberOfRows;
                    setMuiTable(muiTable);
                  },
                  customToolbar: () => {
                    return (
                      <Tooltip title={`Add Price Groups`}>
                        <IconButton
                          onClick={() => {
                            handleModalClose();
                            setCustomGroupName("");
                            setIsLandingPage(false);
                            setActiveStep(0);
                          }}
                        >
                          <AddIcon />
                        </IconButton>
                      </Tooltip>
                    );
                  },
                }}
                title="Price Groups"
                columns={[
                  {
                    label: "Price Group",
                    name: "groupname",
                    options: {
                      filter: true,
                      renderCell: (params) => (
                        <Link
                          component="button"
                          onClick={() => {
                            const filteredPriceGroupData: any = priceGroupData.filter(
                              (ele: any) => ele?.groupname.trim() == params?.value.trim()
                            );
                            const columns: any = dynamicallyChooseColsForMatDetls(params);
                            setDynamicColsForMatDetls(columns);
                            setMaterialDetailsPopupData(filteredPriceGroupData);
                            setOpenMaterialDetailsPopup(true);
                          }}
                        >
                          {params.value}
                        </Link>
                      ),
                    },
                  },
                  {
                    label: "Group Type",
                    name: "group_type",
                    options: {
                      filter: true,
                      searchable: true,
                      renderCell: (params) => {
                        if (params?.value == RESERVED_GROUP_TYPE) {
                          return (
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <HdrAutoOutlinedIcon fontSize="small" />
                              <span>{params.value}</span>
                            </Box>
                          );
                        } else {
                          return (
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <PersonPinCircleOutlinedIcon fontSize="small" />
                              <span>{params.value}</span>
                            </Box>
                          );
                        }
                      },
                    },
                  },
                  {
                    label: "Pack Size",
                    name: "pack_size",
                    valueGetter: (params: any) => {
                      return params?.row?.is_auto ? params?.row?.pack_size : "-";
                    },
                  },
                  {
                    label: "Pack Type",
                    name: "pack_type",
                    valueGetter: (params: any) => {
                      return params?.row?.is_auto ? params?.row?.pack_type : "-";
                    },
                  },
                  {
                    label: "Beverage Category",
                    name: "beverage_cat",
                    options: {
                      filter: true,
                    },
                    valueGetter: (params: any) => {
                      return params?.row?.is_auto ? params?.row?.beverage_cat : "-";
                    },
                  },
                  {
                    label: "Brand",
                    name: "brand",
                    options: {
                      filter: true,
                    },
                    valueGetter: (params: any) => {
                      return params?.row?.is_auto ? params?.row?.brand : "-";
                    },
                  },
                  {
                    label: "Materials",
                    name: "materialCount",
                  },
                  {
                    label: "Action",
                    name: "action",
                    options: {
                      filter: false,
                      renderCell: (params) => {
                        return (
                          <React.Fragment>
                            <Tooltip title={"Edit"}>
                              <IconButton disabled={params.row?.is_auto}>
                                <EditIcon
                                  fontSize="small"
                                  onClick={() => {
                                    setIsEditOperation(true);
                                    setCustomGroupName(params.row?.groupname);
                                    handleEdit(params.row);
                                  }}
                                />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title={"Delete"}>
                              <IconButton disabled={params.row?.is_auto}>
                                <DeleteIcon
                                  fontSize="small"
                                  onClick={() => {
                                    setRecoredToBeDeleted(params.row);
                                    setConfirmDelete(true);
                                  }}
                                />
                              </IconButton>
                            </Tooltip>
                          </React.Fragment>
                        );
                      },
                    },
                  },
                ]}
                data={groupedPriceGroupData}
              />
            ) : enabled ? (
              <div className={classes.centerDiv}>
                <CircularProgress color="primary" />
              </div>
            ) : (
              <Alert severity="error">
                <AlertTitle>
                  <LockIcon /> Access Error
                </AlertTitle>
                You do not currently have access to <strong>Admin</strong> activities for the{" "}
                <strong>{salesOrg}</strong> bottler.
              </Alert>
            )}
          </div>
        ) : (
          <Box
            sx={{
              width: "100%",
              backgroundColor: "#fff",
              boxSizing: "border-box",
              p: 3,
            }}
          >
            <Stepper nonLinear activeStep={activeStep}>
              {steps.map((label, index) => (
                <Step key={label}>
                  <StepButton aria-controls="stepper-content" color="inherit">
                    {label}
                  </StepButton>
                </Step>
              ))}
            </Stepper>
            <div id="stepper-content">
              {activeStep === 0 ? (
                <Grid container spacing={2} className={classes.modalGrid}>
                  <Grid item xl={12}>
                    <Typography
                      variant="subtitle1"
                      className={classes.modalText}
                      paragraph
                      dangerouslySetInnerHTML={{
                        __html: determineConfigLong(codes, "optimization_param", editedRowParamName),
                      }}
                    ></Typography>
                    <Card sx={{ height: "60vh" }}>
                      <CardContent>
                        <Grid container spacing={1} className={classes.modalGrid}>
                          <Grid item xs={"auto"} md={"auto"} xl={"auto"}>
                            <InputLabel>Custom Group Name</InputLabel>
                            <TextField
                              sx={{ marginTop: "15px" }}
                              placeholder="Custom Group Name"
                              helperText="Enter Custom Group Name"
                              type="text"
                              style={{ width: "450px" }}
                              className={classes.modalInput}
                              value={customGroupName}
                              onChange={(e) => {
                                setCustomGroupName(
                                  e.target.value && typeof e.target.value == "string" ? e.target.value : ""
                                );
                              }}
                            ></TextField>
                          </Grid>
                          <Grid item xs={"auto"} md={"auto"} xl={"auto"} marginLeft={5}>
                            <InputLabel>Price Group/Material</InputLabel>
                            <Autocomplete
                              options={combinedGroupMatrialList}
                              style={{ width: "450px" }}
                              value={rowMaterial.searchMaterial}
                              getOptionLabel={(option: any) => option?.groupname}
                              onChange={(_, newMat) => {
                                setRowMaterial({
                                  ...rowMaterial,
                                  searchMaterial: newMat,
                                });
                                // setEditedRowMaterialNum((newMat&&  typeof newMat== 'string') ? newMat: "*");
                              }}
                              onKeyDown={(event) => {
                                if (event.key === "Enter" && (event.target as any).value) {
                                  const newMat = (event.target as any).value;
                                  setRowMaterial({ ...rowMaterial, searchMaterial: newMat });
                                  // setEditedRowMaterialNum((newMat&&  typeof newMat== 'string') ? newMat: "*");
                                }
                              }}
                              //  disabled={!editedRowMaterialNum}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Search Price Group/Material"
                                  helperText="Select Price Group/Material to be added"
                                  variant="standard"
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={"auto"} md={"auto"} xl={"auto"} marginLeft={10} marginTop={3}>
                            <Button
                              color="primary"
                              variant="contained"
                              className={classes.paragraphButton}
                              style={{ width: "130px" }}
                              onClick={handleAddTableData}
                            >
                              + Add
                            </Button>
                          </Grid>
                        </Grid>
                        <Grid container spacing={1} className={classes.modalGrid} marginTop={2}>
                          <Grid item xs={"auto"} md={"auto"} xl={"auto"} sx={{ display: "none" }}>
                            <Button
                              color="primary"
                              variant="contained"
                              className={classes.paragraphButton}
                              onClick={(event) => {
                                // Feature downloadPriceGroupCSV is implemeted, but it will be improved further till then
                                //a message will be shown as Coming Soon and return;
                                setComingSoonPopup(true);
                                return;
                                //downloading the sample CSV file for Price Group
                                downloadPriceGroupCSV(salesOrg).then((reply: any) => {
                                  const url = window.URL.createObjectURL(new Blob([reply.data], { type: "text/csv" }));
                                  const link = document.createElement("a");
                                  link.href = url;
                                  link.setAttribute("download", `RemotePrice_PriceGroup_Template.csv`);
                                  document.body.appendChild(link);
                                  link.click();
                                });
                              }}
                            >
                              <GetApp /> Get Template
                            </Button>
                          </Grid>
                          {bulkMessage && !bulkErrorBody /* Upload Detected */ ? (
                            <Grid item xs={"auto"} md={"auto"} xl={"auto"} marginLeft={40} height={40} width={70}>
                              <Card>
                                <CardContent>
                                  <Box display="flex" alignItems="center" gap={2}>
                                    <div>
                                      <Typography variant="h6" className={classes.paragraph}>
                                        Approve Changes
                                      </Typography>
                                      <Typography variant="subtitle1" className={classes.paragraphAct} paragraph>
                                        {bulkMessage}
                                      </Typography>
                                    </div>
                                    <Alert severity="warning">
                                      <AlertTitle>Price Group Creation Summary</AlertTitle>
                                      <p>Valid: {bulkSummary?.valid}</p>
                                      <p>Invalid: {bulkSummary?.invalid}</p>
                                    </Alert>
                                  </Box>
                                </CardContent>
                              </Card>
                            </Grid>
                          ) : bulkMessage && bulkErrorBody ? (
                            <Grid item xl={"auto"} marginLeft={40} height={40}>
                              <Card className={classes.card}>
                                <CardContent>
                                  <Box display="flex" alignItems="center" gap={2}>
                                    <div>
                                      <Typography variant="h6" className={classes.paragraph}>
                                        Could not process file
                                      </Typography>
                                      <Alert severity="error">
                                        <AlertTitle>Error</AlertTitle>
                                        {bulkMessage}
                                      </Alert>
                                    </div>
                                    {bulkErrorBody.duplicatePriceGroup ? (
                                      <div style={{ marginTop: "45px;" }}>
                                        <Alert severity="warning">
                                          <AlertTitle>Duplicate Price Group</AlertTitle>
                                          {bulkErrorBody.duplicatePriceGroup.join(", ")}
                                        </Alert>
                                      </div>
                                    ) : (
                                      <div></div>
                                    )}
                                  </Box>
                                </CardContent>
                              </Card>
                            </Grid>
                          ) : (
                            <div></div>
                          )}
                        </Grid>
                        <Grid container spacing={1} className={classes.modalGrid} marginTop={1}>
                          <Grid item xs={"auto"} md={"auto"} xl={"auto"} sx={{ display: "none" }}>
                            <Button
                              color="primary"
                              component="label"
                              variant="contained"
                              className={classes.paragraphButton}
                              onClick={(event: any) => {
                                // Temporaray onclick event to just show the coming soon message
                                //once feature is furtehr improved remove this onclick.
                                setComingSoonPopup(true);
                                event.preventDefault();
                                return;
                              }}
                            >
                              <Attachment style={{ marginRight: 3 }} /> Select File
                              <input
                                type="file"
                                name="banks"
                                id="bank-file"
                                hidden
                                onChange={(e) => {
                                  setSelectedFile(undefined);
                                  if (e.target.files) {
                                    setSelectedFile(e.target.files[0]);
                                    setfileName(e.target.files[0].name);
                                    e.target.value = "";
                                  }
                                }}
                              />
                            </Button>
                            <TextField
                              sx={{ marginLeft: "20px", marginTop: "15px", width: "180px" }}
                              placeholder="File"
                              type="text"
                              value={fileName}
                            />
                            <Button
                              color="primary"
                              variant="contained"
                              className={classes.paragraphButton}
                              style={{ marginLeft: "20px" }}
                              disabled={selectedFile ? false : true}
                              onClick={(event) => {
                                //
                                if (selectedFile) {
                                  setBackdropLoader(true);
                                  setBulkSummary(undefined);
                                  setBulkADD(undefined);
                                  setBulkMessage(undefined);
                                  setBulkKeyId(undefined);
                                  setModifyTableData([]);
                                  uploadPriceGroupCSV(salesOrg, selectedFile).then((result: any) => {
                                    if (result && result.status < 400) {
                                      if (result.data.priceGroupDelta) {
                                        setBulkSummary(result.data.priceGroupDelta.counts);
                                        setModifyTableData(result.data.priceGroupDelta.ADD);
                                        setBulkKeyId(result.data.keyId);
                                        setBulkErrorBody(undefined);
                                      }
                                    } else {
                                      setBulkErrorBody(result?.data || { error: "UNKNOWN ERROR" });
                                    }
                                    let message: string =
                                      result?.data?.message ||
                                      "An UNKNOWN ERROR occured! This may have been caused by modifying the file after selecting it. Please try renaming the file, then uploading the renamed file again. If this does not resolve, please reach out to CONA Services with an incident.";
                                    setBulkMessage(message);
                                    setBackdropLoader(false);
                                  });
                                }
                              }}
                            >
                              <Publish /> Upload
                            </Button>
                          </Grid>
                        </Grid>
                        <Grid container>
                          <Grid item xs={"auto"} md={12} xl={12}>
                            <Card>
                              <TableAbstraction
                                settingsKey="ADM_BN"
                                options={{
                                  draggableColumns: {
                                    enabled: true,
                                  },
                                  serverSide: false,
                                  selectableRows: "none",
                                  tableBodyHeight: "400px",
                                }}
                                title="Custom Group Data Set"
                                columns={[
                                  // salesOffice:string, bankID: string, bankName: string, customerNum:string, change:string
                                  {
                                    label: "Price Group",
                                    name: "groupname",
                                    options: {
                                      filter: true,
                                    },
                                  },
                                  {
                                    label: "Pack Size",
                                    name: "pack_size",
                                  },
                                  {
                                    label: "Pack Type",
                                    name: "pack_type",
                                  },
                                  {
                                    label: "Beverage Category",
                                    name: "beverage_cat",
                                  },
                                  {
                                    label: "Brand",
                                    name: "brand",
                                  },
                                  //Commenting temporarly as import price grup functionality is coming up
                                  //This section is usefull for that functionality
                                  // {
                                  //   label: "Valid",
                                  //   name: "valid",
                                  //   options: {
                                  //     searchable: true,
                                  //     filter: true,
                                  //     customBodyRender: (value: any) => {
                                  //       return value === "Yes" ? (
                                  //         <AddCircle style={{ color: "Green" }} />
                                  //       ) : (
                                  //         <RemoveCircle style={{ color: "Red" }} />
                                  //       );
                                  //     },
                                  //   },
                                  // },
                                  {
                                    label: "Action",
                                    name: "action",
                                    options: {
                                      filter: false,
                                      renderCell: (params) => {
                                        return (
                                          <React.Fragment>
                                            <Tooltip title={"Delete"}>
                                              <DeleteIcon
                                                fontSize="small"
                                                onClick={() => {
                                                  handleTableDataDelete(params.row);
                                                }}
                                              />
                                            </Tooltip>
                                          </React.Fragment>
                                        );
                                      },
                                    },
                                  },
                                ]}
                                data={modifyTableData}
                              />
                            </Card>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                    <div style={{ paddingRight: "5px", textAlign: "right" }}>
                      <React.Fragment>
                        <Button
                          variant="contained"
                          disabled={disabledSaveButton}
                          color="primary"
                          onClick={handleModalSave}
                        >
                          Save
                        </Button>
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={() => {
                            handleModalClose();
                            setIsLandingPage(true);
                          }}
                        >
                          Cancel
                        </Button>
                      </React.Fragment>
                    </div>
                  </Grid>
                </Grid>
              ) : (
                <></>
              )}
            </div>
          </Box>
        )}

        {/* Material Details popup */}
        <Modal open={openMaterialDetailsPopup} onClose={handleModalClose}>
          <div style={modalStyle} className={classes.paper}>
            <IconButton
              aria-label="close"
              onClick={() => {
                handleModalClose();
              }}
              sx={{ position: "absolute", right: 16, top: 16, color: (theme) => theme.palette.grey[500] }}
            >
              <CloseIcon />
            </IconButton>
            <Grid container spacing={2} className={classes.modalGrid} marginTop={5}>
              <Grid item xs={12}>
                <Card>
                  <TableAbstraction
                    settingsKey="ADM_BN"
                    options={{
                      draggableColumns: {
                        enabled: true,
                      },
                      serverSide: false,
                      selectableRows: "none",
                    }}
                    title="Material Details"
                    columns={dynamicColsForMatDetls}
                    data={materialDetailsPopupData}
                  />
                </Card>
              </Grid>
            </Grid>
          </div>
        </Modal>

        {/* Delete confirmation popup */}
        <Dialog open={confirmDelete} onClose={() => setConfirmDelete(false)}>
          <DialogTitle>Confirm Deletion</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you would like to delete Price Group: {recoredToBeDeleted?.groupname}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                handleDelete();
                setConfirmDelete(false);
              }}
              color="primary"
            >
              Yes
            </Button>
            <Button
              onClick={() => {
                setRecoredToBeDeleted(undefined);
                setConfirmDelete(false);
              }}
              color="primary"
              autoFocus
            >
              No
            </Button>
          </DialogActions>
        </Dialog>

        {/* Page common alert message popup */}
        <Dialog open={commonAlert.isAlertOpen} onClose={() => setCommonAlert({ ...commonAlert, isAlertOpen: false })}>
          <DialogTitle>{commonAlert.alertTitle}</DialogTitle>
          <DialogContent>
            <DialogContentText>{commonAlert.alertMessage}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setCommonAlert({ ...commonAlert, isAlertOpen: false });
              }}
              color="primary"
              autoFocus
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>

        {/* Feature Coming Soon Popup */}
        <Dialog
          open={comingSoonPopup}
          onClose={() => {
            setComingSoonPopup(false);
          }}
          maxWidth="xs"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 4,
              padding: 2,
              textAlign: "center",
              position: "relative",
              overflow: "visible", // Allows visual elements to slightly overlap if needed
            },
          }}
        >
          {/* Close Button top-right */}
          <IconButton
            aria-label="close"
            onClick={() => {
              setComingSoonPopup(false);
            }}
            sx={{
              position: "absolute",
              right: 16,
              top: 16,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>

          <DialogContent sx={{ pt: 4, pb: 2 }}>
            {/* Animated/Styled Icon Container */}
            <Box
              sx={{
                display: "inline-flex",
                backgroundColor: "primary.lightest", // Customize with your theme values
                bgcolor: "action.hover",
                p: 3,
                borderRadius: "50%",
                mb: 3,
              }}
            >
              <RocketIcon sx={{ fontSize: 50, color: "primary.main" }} />
            </Box>

            {/* Heading & Copy */}
            <Typography variant="h5" component="h2" fontWeight="700" gutterBottom>
              Feature Coming Soon!
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 4, px: 2 }}>
              We are hard at work building this feature to improve your experience.
            </Typography>
          </DialogContent>
        </Dialog>
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => Math.max.apply(Math, Object.values(theme.zIndex)) + 1,
          }}
          open={backdropLoader}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </>
  );
}
